import API from 'js/lib/api';

export default API('/api/productOwnerships.v1', {
  type: 'rest',
});
